<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row justify="center" class="mx-10">
      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Corporates") }}</h2>
          </div>
          <router-link :to="'/settings/clients'" v-if="$ha(300)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-briefcase-account</v-icon> -->
              {{ $i18n.t("Clients") }}
            </h4>
          </router-link>
          <router-link :to="'/settings/vendor'" v-if="$ha(290)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-account-star</v-icon> -->
              {{ $i18n.t("Vendors") }}
            </h4>
          </router-link>
          <router-link :to="'/entity'" v-if="$ha(700)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-domain</v-icon> -->
              {{ $i18n.t("Entities") }}
            </h4>
          </router-link>
          <router-link :to="'/branch'" v-if="$ha(700)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-domain</v-icon> -->
              {{ $i18n.t("Branches") }}
            </h4>
          </router-link>
        </div>

        <div class="py-1 my-12">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Users") }}</h2>
          </div>
          <router-link :to="'/settings/supervisor'" v-if="$ha(210)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-shield-account</v-icon> -->
              {{ $i18n.t("Supervisors") }}
            </h4>
          </router-link>
          <router-link :to="'/settings/zone'" v-if="$ha(200)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-file-tree</v-icon> -->
              {{ $i18n.t("Zones") }}
            </h4>
          </router-link>
          <router-link :to="'/role'" v-if="$ha(530)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-account-tie</v-icon> -->
              {{ $i18n.t("User Roles") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Masters") }}</h2>
          </div>
          <router-link v-if="$ha(760)" :to="'/settings/campuses'">
            <h4 class="my-5">
              {{ $i18n.t("Campuses") }}
            </h4>
          </router-link>
          <router-link :to="'/settings/citygroup'" v-if="$ha(340)">
            <h4 class="my-5">
              {{ $i18n.t("City Groups") }}
            </h4>
          </router-link>
          <!-- <a href="settings/compliance" v-if="$ha(130)" >
            <h4 class="my-5">
              {{ $i18n.t("Compliance") }}
            </h4>
          </a> -->
          <router-link :to="'/settings/garage'">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-garage-alert-variant</v-icon> -->
              {{ $i18n.t("Garage") }}
            </h4>
          </router-link>
          <!-- <a href="/handovers">
            <h4 class="my-5">
              {{ $i18n.t("Handover") }}
            </h4>
          </a> -->
          <router-link :to="'/settings/inventory'">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-warehouse</v-icon> -->
              {{ $i18n.t("Inventory") }}
            </h4>
          </router-link>
          <router-link :to="'/qctemplate'">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-beaker-check</v-icon> -->
              {{ $i18n.t("QC Template") }}
            </h4>
          </router-link>
          <router-link :to="'/qcchecks'">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-notebook-check</v-icon> -->
              {{ $i18n.t("QC Check") }}
            </h4>
          </router-link>
          <router-link :to="'/w/screen/all'" v-if="$ha(970)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-marker-check</v-icon> -->
              {{ $i18n.t("Screens") }}
            </h4>
          </router-link>
          <router-link :to="'/corporate/staticContent/all'" v-if="$ha(560)">
            <h4 class="my-5">
              {{ $i18n.t("Static Content") }}
            </h4>
          </router-link>
          <router-link :to="'/settings/template'" v-if="$ha(980)">
            <h4 class="my-5">
              {{ $i18n.t("Template") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Journey Configuration") }}</h2>
          </div>
          <router-link :to="'/setting/booking'" v-if="$ha(340)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-car-cog</v-icon> -->
              {{ $i18n.t("Trip Settings") }}
            </h4>
          </router-link>
          <router-link :to="'/other/setting'" v-if="$ha(340)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-cog</v-icon> -->
              {{ $i18n.t("Other Settings") }}
            </h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="3" class="px-5 py-5">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Configuration") }}</h2>
          </div>
          <router-link :to="'/settings/helplines'" v-if="$ha(340)">
            <h4 class="my-5">
              {{ $i18n.t("Helpline") }}
            </h4>
          </router-link>
          <router-link :to="'/settings/paymentgateway'" v-if="$ha(600)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-credit-card-plus</v-icon> -->
              {{ $i18n.t("Payment Gateway") }}
            </h4>
          </router-link>
          <router-link :to="'settings/emailSetup'" v-if="$ha(340)">
            <h4 class="my-5">
              <!-- <v-icon color="primary" class="me-5">mdi-email-alert</v-icon> -->
              {{ $i18n.t("Email Setup") }}
            </h4>
          </router-link>
          <router-link :to="'/w/corporate/corpConfig/tag'" v-if="$ha(340)">
            <h4 class="my-5">
              {{ $i18n.t("Tags") }}
            </h4>
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SettingsMenu",

  data() {
    return {};
  },

  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
